import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#00ADEE",
  "fill-rule": "evenodd",
  d: "M24.889 3.368V0h-3.556v3.368H10.667V0H7.11v3.368H0V32h32V3.368h-7.111ZM7.11 6.737v3.368h3.556V6.737h10.666v3.368h3.556V6.737h3.555v6.737H3.555V6.737h3.556ZM3.556 16.844v11.79h24.888v-11.79H3.555Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };